<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("managementGPTModel") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <!-- ส่วนค้นหา -->
            <v-col cols="12" md="8">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="12" sm="5" class="pa-2">
                    <v-text-field
                      id="search-modelid-gptmodelmanagement"
                      label="Model ID"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-identifier"
                      hide-details
                      clearable
                      v-model="searchModelId"
                      @keypress="isNumberpositive($event)"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="5" class="pa-2">
                    <v-text-field
                      id="search-modelname-gptmodelmanagement"
                      label="Model Name"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-text-box-search-outline"
                      hide-details
                      clearable
                      v-model="searchModelName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="2" class="pa-2 d-flex align-center">
                    <v-btn
                      id="button-search-gptmodelmanagement"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      Search
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- ส่วนปุ่มการทำงาน -->
            <v-col cols="12" md="4" class="d-flex flex-wrap justify-end gap-2">
              <div class="action-controls">
                <v-btn
                  :color="compareMode ? 'error' : 'primary'"
                  class="control-btn"
                  :variant="compareMode ? 'tonal' : 'outlined'"
                  size="small"
                  @click="toggleCompareMode"
                >
                  <v-icon start size="18">{{ compareMode ? 'mdi-close' : 'mdi-compare-horizontal' }}</v-icon>
                  {{ compareMode ? 'EXIT COMPARE' : 'COMPARE' }}
                </v-btn>

                <v-divider vertical thickness="1" length="40" class="mx-2"></v-divider>

                <!-- Import Button -->
                <v-btn
                  v-if="permissions.add"
                  id="button-import-gptmodelmanagement"
                  color="info"
                  class="control-btn import-btn"
                  variant="flat"
                  size="large"
                  prepend-icon="mdi-file-import"
                  @click="openImportDialog"
                  rounded="lg"
                >
                  IMPORT
                  <v-tooltip activator="parent" location="top">
                    Import file configuration
                  </v-tooltip>
                </v-btn>

                <!-- Divider -->
                <v-divider v-if="permissions.add" vertical thickness="1" length="50" class="mx-4"></v-divider>

                <!-- Create Button -->
                <v-btn
                  v-if="permissions.add"
                  id="button-create-gptmodelmanagement"
                  color="primary"
                  class="control-btn create-btn"
                  variant="flat"
                  size="small"
                  prepend-icon="mdi-plus-circle"
                  @click="Add()"
                  rounded="lg"
                >
                  CREATE
                  <v-tooltip activator="parent" location="top">
                    Create new GPT model
                  </v-tooltip>
                </v-btn>
              </div>
              
              <!-- Hidden File Uploader for Import dialog -->
              <input
                ref="importFileInput"
                type="file"
                accept=".json"
                style="display: none"
                @change="handleImportFileSelected"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          class="modern-table"
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="menus"
          :headers="computedHeaders"
          :loading="loadingTable"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td v-if="compareMode" style="text-align: center">
                <v-checkbox-btn
                  :model-value="isModelSelectedForCompare(item.modelId)"
                  color="primary"
                  @update:model-value="toggleCompareSelection('model', item)"
                />
              </td>
              <td style="text-align: center">{{ item.modelDisplay }}</td>
              <td>{{ item.modelName }}</td>
              <td>
                <v-menu location="bottom">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      icon
                      v-bind="props"
                      variant="text"
                      density="comfortable"
                    >
                      <v-icon id="icon-iconmenu-gptmodelmanagement" size="22"
                        >mdi-dots-horizontal</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="permissions.edit" @click="changePublishNow(item, true)">
                      <v-list-item-title id="list-publish-gptmodelmanagement"
                        >Publish</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item v-if="permissions.edit" @click="Replace(item.modelId, item.modelName)">
                      <v-list-item-title id="list-replace-gptmodelmanagement">{{
                        $t("gpt_model_management_replace")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="Version(item.modelId, item.modelIDGroup)"
                    >
                      <v-list-item-title id="list-version-gptmodelmanagement">{{
                        $t("gpt_model_management_version_history")
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="Exportfileconfig(item.modelId, item.modelDisplay, item.modelName)">
                      <v-list-item-title
                        id="list-exportfileconfig-gptmodelmanagement"
                        >{{
                          $t("gpt_model_management_export_file_config")
                        }}</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
              <td>{{ item.flowName && item.flowName.trim() ? item.flowName : "-" }}</td>
              <td style="text-align: center">{{ item.flowUpdateDate ? new Date(item.flowUpdateDate + 'Z').toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).replace(',', '') : "-" }}</td>
              <td>{{ item.provider }}</td>
              <td>{{ item.modelNameDisplay }}</td>
              <td style="text-align: center">{{ item.createBy }}</td>
              <td style="text-align: center">
                {{ item.isPublish == true ? "Publish" : "Draft" }}
              </td>
              <td style="text-align: center">
                <div class="action-group" style="display: flex; justify-content: center">
                  <v-btn
                    v-if="permissions.edit || permissions.view"
                    id="button-edit-uploadCSV"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-icon size="18">{{ isViewOnly ? 'mdi-eye-outline' : 'mdi-pencil-outline' }}</v-icon>
                    <v-tooltip activator="parent" location="top">
                      {{ isViewOnly ? 'View' : 'Edit' }}
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->
                  <div class="action-divider" v-if="permissions.edit && permissions.delete && item.modelDisplay != 1"></div>

                  <!-- Delete -->
                  <v-btn
                    v-if="permissions.delete && item.modelDisplay != 1"
                    id="button-delete-uploadCSV"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item)"
                    class="action-btn delete-btn"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>

      <!-- Compare Mode Floating Bar -->
      <v-slide-y-reverse-transition>
        <div v-if="compareMode" class="compare-floating-bar">
          <div class="compare-floating-content">
            <div class="compare-floating-selections">
              <div class="compare-floating-label">
                <v-icon size="18" class="mr-1">mdi-compare-horizontal</v-icon>
                Compare
              </div>
              <template v-if="selectedCompareModels.length > 0 || importedJsonFile">
                <v-chip
                  v-for="model in selectedCompareModels"
                  :key="model.modelId"
                  closable
                  color="primary"
                  variant="flat"
                  size="small"
                  class="compare-chip-item"
                  @click:close="removeCompareModel(model.modelId)"
                >
                  #{{ model.modelDisplay }} {{ model.modelName || 'Unnamed' }}
                </v-chip>
                <v-chip
                  v-if="importedJsonFile"
                  closable
                  color="orange"
                  variant="flat"
                  size="small"
                  class="compare-chip-item"
                  @click:close="removeImportedJson"
                >
                  <v-icon start size="16">mdi-file-code-outline</v-icon>
                  {{ importedJsonFile.name }}
                </v-chip>
              </template>
              <span v-else class="compare-floating-hint">Select 2 models or 1 model + JSON file to compare</span>
            </div>
            <div class="compare-floating-actions">
              <v-btn
                color="orange"
                variant="tonal"
                size="small"
                :disabled="compareSlotCount >= 2"
                @click="triggerJsonCompareUpload"
              >
                <v-icon start size="18">mdi-code-json</v-icon>
                FROM FILE
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                size="small"
                :disabled="compareSlotCount !== 2"
                :loading="compareLoading"
                @click="openCompareFromSelection('model')"
              >
                <v-icon start size="18">mdi-file-compare</v-icon>
                COMPARE
              </v-btn>
              <v-btn
                variant="outlined"
                size="small"
                @click="toggleCompareMode"
              >
                CANCEL
              </v-btn>
            </div>
            <input
              ref="jsonCompareInput"
              type="file"
              accept=".json"
              style="display: none"
              @change="handleJsonCompareFile"
            />
          </div>
        </div>
      </v-slide-y-reverse-transition>
    </v-container>
    <!-- Dialog Replace -->
    <!-- Dialog Import -->
    <v-dialog v-model="dialog_import" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            Import File Configuration
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="importForm" v-model="importFormValid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    id="input-name-popupimport-gptmodelmanagement"
                    :label="'Model Name*'"
                    v-model="importModelName"
                    :rules="[rules.required]"
                    outlined
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-btn
                    id="button-choosefile-popupimport-gptmodelmanagement"
                    color="info"
                    variant="tonal"
                    prepend-icon="mdi-file-upload"
                    @click="$refs.importFileInput.click()"
                  >
                    {{ importFileNameRaw ? "Change File" : "Choose File*" }}
                  </v-btn>
                  <span v-if="importFileNameRaw" class="ml-3">{{ importFileNameRaw }}</span>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="importFileNameRaw">
                  <v-btn
                    id="button-validatefile-popupimport-gptmodelmanagement"
                    color="orange darken-2"
                    variant="outlined"
                    prepend-icon="mdi-check-decagram-outline"
                    :disabled="importCatalogLoading"
                    :loading="importCatalogLoading"
                    @click="validateImportFile"
                  >
                    Validate File
                  </v-btn>
                  <span v-if="importCatalogLoading" class="ml-3">Loading model catalog...</span>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="importValidation.checked">
                  <v-alert
                    :type="importValidation.valid ? 'success' : 'error'"
                    density="compact"
                    variant="tonal"
                  >
                    <div v-if="importValidation.valid">Valid configuration file.</div>
                    <ul v-else style="margin: 0; padding-left: 18px">
                      <li v-for="(err, i) in importValidation.errors" :key="i">{{ err }}</li>
                    </ul>
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeImportDialog">{{
            $t("close")
          }}</v-btn>
          <v-btn
            id="button-importsave-popupimport-gptmodelmanagement"
            color="blue darken-1"
            text
            :disabled="!canSubmitImport"
            :loading="importSubmitting"
            @click="submitImport"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_replace" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_replace") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div style="margin-bottom: 2%">
              {{ replace_modelName }}
              <v-icon size="20" style="padding-right: 5px"
                >mdi-chevron-double-right</v-icon
              >
              <span style="color: #1d4f81; font-weight: bold">{{
                replace_modelName2
              }}</span>
            </div>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    id="model-autocomplete-popupreplace-gptmodelmanagement"
                    :label="'Model*'"
                    :rules="[rules.required]"
                    :items="replace_modelid_lists"
                    item-title="modelName"
                    item-value="modelIDGroup"
                    v-model="replace_modelid_list"
                    clearable
                    outlined
                    required
                    @change="
                      replace_modelName2 = replace_modelid_lists.find(
                        (e) => e.modelIDGroup == replace_modelid_list
                      ).modelName
                    "
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
          color="blue darken-1" 
          text 
          @click="dialog_replace = false">{{
            $t("close")
          }}</v-btn>
          <v-btn
            id="button-replacesave-popupreplace-gptmodelmanagement"
            color="blue darken-1"
            text
            @click="ReplaceSave"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Version -->
    <v-dialog v-model="dialog_version" max-width="800px">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_version_history") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table-server
              id="table-dialogversion-gptmodelmanagement"
              :items-per-page="options_version.itemsPerPage"
              :items-length="totalTable_version"
              v-model:options="options_version"
              :items="menus_version"
              :headers="headers_version_history"
              :items-per-page-options="[5, 10, 15]"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">
                    <v-checkbox-btn
                      :model-value="isVersionSelectedForCompare(item.modelId)"
                      color="primary"
                      @update:model-value="toggleCompareSelection('version', item.modelId)"
                    />
                  </td>
                  <td style="text-align: center">
                    <div style="position: relative; display: inline-block">
                      <span
                        v-if="item.isPublish === true"
                        style="
                          position: absolute;
                          top: -6px;
                          left: -70px;
                          z-index: 1;
                        "
                      >
                        <v-chip color="primary" size="small" label>{{
                          $t("latest")
                        }}</v-chip>
                      </span>
                      <div>{{ item.versioning }}</div>
                    </div>
                  </td>
                  <td style="text-align: center">
                    <div class="version-comment-cell" style="max-width: 200px; white-space: normal; word-break: break-word;">
                      <v-tooltip v-if="item.versionComment" activator="parent" location="top" max-width="300">
                        {{ item.versionComment }}
                      </v-tooltip>
                      {{ item.versionComment || '-' }}
                    </div>
                  </td>
                  <td style="text-align: center">{{ item.updateDate }}</td>
                  <td style="text-align: center">
                    <v-menu location="bottom">
                      <template v-slot:activator="{ props }">
                        <v-btn 
                        icon 
                        variant="text"
                        density="comfortable"
                        v-bind="props">
                          <v-icon
                            id="icon-iconmenu-popupversion-gptmodelmanagement"
                            size="22"
                            >mdi-dots-horizontal</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list>
                        <!--Restore-->
                        <v-list-item
                          v-if="permissions.edit"
                          :key="item.modelId"
                          @click="changeRestoreNewVersion(item)"
                        >
                          <v-list-item-title
                            id="list-restore-popupversion-gptmodelmanagement"
                            >Restore</v-list-item-title
                          >
                        </v-list-item>
                        <!--View-->
                        <v-list-item @click="view(item)">
                          <v-list-item-title
                            id="list-view-popupversion-gptmodelmanagement"
                            >View</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td style="text-align: center">{{ item.updateBy }}</td>
                </tr>
              </template>
            </v-data-table-server>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            variant="outlined"
            :disabled="selectedCompareVersionIds.length !== 2 || compareLoading"
            :loading="compareLoading"
            @click="openCompareFromSelection('version')"
          >
            Compare {{ selectedCompareVersionIds.length }}/2
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_version = false">{{
            $t("close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--dialog version history view-->
    <v-dialog v-model="dialog_View">
      <v-card>
        <v-card-title>
          <p class="headline" style="color: #1d4f81">
            {{ $t("gpt_model_management_version_history_detail") }}
          </p>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ModelManagement
              v-if="dialog_View"
              :LLmsModel="GPTModel"
              :editAction="null"
              :modelID="view_modelID"
              :GetDDModel="isParam"
              :page="isPage"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog_View = false">{{
            $t("close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_compare" max-width="1200px" scrollable>
      <v-card class="compare-dialog-card">
        <v-card-title class="compare-dialog-header">
          <div>
            <div class="compare-dialog-title">{{ compareContextLabel }}</div>
            <div class="compare-dialog-subtitle">Review configuration differences as a summary or full side-by-side comparison.</div>
          </div>
        </v-card-title>
        <v-card-text>
          <GPTModelCompare
            v-if="comparePayload.leftModel && comparePayload.rightModel"
            :left-model="comparePayload.leftModel"
            :right-model="comparePayload.rightModel"
            :left-title="comparePayload.leftTitle"
            :right-title="comparePayload.rightTitle"
            default-view="summary"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="outlined" @click="closeCompareDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>


<script>
import ModelManagement from "@/components/ModelManagement.vue";
import GPTModelCompare from "@/components/GPTModelCompare.vue";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
// use i18n for internationalization
export default {
  name: "GPTModelManagement",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  components: { ModelManagement, GPTModelCompare },
  
  data: () => ({
    loadingTable: false,
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    options_version: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDVector: [],
    DDProvider: [
      "Azure",
      "Azure Postgresql",
      "Azure Internet",
      "Azure Internet",
      "Azure News",
    ],
    DDModel: [
      {
        provider: "Azure",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure",
        model: "gpt-4",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-postgresql",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-35-16k-postgresql",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Postgresql",
        model: "gpt-4-postgresql",
        maxPrompt: 6000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-Internet",
        maxPrompt: 4000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-35-16k-Internet",
        maxPrompt: 8000,
      },
      {
        provider: "Azure Internet",
        model: "gpt-4-Internet",
        maxPrompt: 6000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-chat",
        maxPrompt: 4000,
      },
      {
        provider: "Azure News",
        model: "gpt-35-turbo-16k",
        maxPrompt: 8000,
      },
      {
        provider: "Azure News",
        model: "gpt-4",
        maxPrompt: 6000,
      },
    ],
    DDModelShow: [],
    headers: [],
    headers_version_history: [],
    DDGender: [
      {
        id: "m",
        name: "Male",
      },
      {
        id: "f",
        name: "Female",
      },
    ],

    searchModelName: "",
    searchModelId: "",
    isSearch: false,
    isFirst: true,
    menus: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    GPTModel: {
      typeLLM: null,
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: "",
      gender: null,
      vectordbName: null,
      topVDB: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      versioning: null,
      isPublish: false,
      modelIDGroup: null,
      modelDisplay: null,
      DataIntegrationID: null,
      SqlModelID: null,
      promptSqlNoData: null,
      IntentGroupID: null,
      typingSpeed: null,
      isBypass: null,
      isAllowImage: null,
      isFeedback: null,
      groupReplaceID: null,
      productGroupID: null,
      cosine: null,
      isLongTerm_Memory: null,
      isChainMassage: null,
      lenChainMassage: null,
      len_ShortMemory: null,
      timeSecondChainMassage: null,
      maximumChatInput: null,
      monitorLineUserId: null,
      isShowNameUserMonitor: null,
      monitorSocialId: null,
      forbiddenWord: null,
      GuardRailModelID: null,
      enableTime: null,
      timeZone: null,
      jsonRequest: null,
      isAllowLLMChange: null,
      productTopVDB: null,
      productCosine: null,
      loadingBarFlag: null,
      loadingBarTime: null,
    },
    dialog_replace: false,
    dialog_View: false,
    replace_modelid: 0,
    replace_modelName: "",
    replace_modelName2: "",
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modelid_version: 0,
    menus_modeliddisplay_version: 0,
    compareMode: false,
    selectedCompareModels: [],
    selectedCompareVersionIds: [],
    importedJsonFile: null,
    dialog_compare: false,
    compareLoading: false,
    compareContextLabel: "",
    comparePayload: {
      leftModel: null,
      rightModel: null,
      leftTitle: "",
      rightTitle: "",
    },
    searchTotalTable_version: 0,
    totalTable_version: 0,
    itemsPerPage_version: 5,
    sortBy: [],
    sortDesc: [],

    isParam: "getModel",
    isPage: "Model Creator",
    view_modelID: null,
    view_Model: {
      modelId: null,
      modelName: null,
      provider: null,
      model: null,
      APIVersion: null,
      extension: null,
      description: null,
      promptTemplate: "",
      gender: null,
      vectordbName: [],
      groupReplaceID: null,
      productGroupID: null,
      topVDB: null,
      internet: null,
      feedback: null,
      historyCount: null,
      historyMinute: null,
      temperature: null,
      topP: null,
      frequencyPenalty: null,
      presencePenalty: null,
      stop: null,
      maxTokens: null,
      isStream: false,
      isBypass: false,
      isFeedback: false,
      isAllowImage: false,
      versioning: null,
      isPublish: true,
      modelIDGroup: null,
      modelDisplay: null,
      Len_ShortMemory: null,
      IsLongTerm_Memory: false,
      IsChainMassage: null,
      LenChainMassage: null,
      TimeSecondChainMassage: null,
      Cosine: null,
      DataIntegrationID: null,
      SqlModelID: null,
      promptSqlNoData: null,
      IntentGroupID: null,
      maximumChatInput: 200000,
      enableTime: null,
      timeZone: null,
    },
    dialog_import: false,
    importFormValid: true,
    importJsonData: null,
    importFileRawText: "",
    importFileNameRaw: "",
    importModelName: "",
    importValidation: { checked: false, valid: false, errors: [] },
    importSubmitting: false,
    // Real model catalog (same source as ModelManagement.vue's create/edit form),
    // used to validate imported provider/model instead of the stale local DDProvider/DDModel arrays.
    importModelCatalog: { providers: [], models: [] },
    importCatalogLoading: false,
    importCatalogLoaded: false,
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    options_version: {
      handler() {
        if (this.menus_modelid_version != 0)
          this.Version(
            this.menus_modelid_version,
            this.menus_modeliddisplay_version
          );
      },
      deep: true,
    },
  },
  computed: {
    computedHeaders() {
      if (this.compareMode) return this.headers;
      return this.headers.filter((h) => h.value !== "compare");
    },
    compareSlotCount() {
      return this.selectedCompareModels.length + (this.importedJsonFile ? 1 : 0);
    },
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('GPTModelManagement');
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('GPTModelManagement'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('GPTModelManagement'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('GPTModelManagement'),
        view: this.isViewOnly,
      }
    },
    canSubmitImport() {
      return this.importValidation.valid && this.importModelName.trim().length > 0;
    },
  },
  methods: {
    openImportDialog() {
      this.resetImportState();
      this.dialog_import = true;
      this.loadImportModelCatalog();
    },
    closeImportDialog() {
      this.dialog_import = false;
      this.resetImportState();
    },
    resetImportState() {
      this.importJsonData = null;
      this.importFileRawText = "";
      this.importFileNameRaw = "";
      this.importModelName = "";
      this.importValidation = { checked: false, valid: false, errors: [] };
      if (this.$refs.importFileInput) {
        this.$refs.importFileInput.value = "";
      }
    },
    // Loads the real provider/model catalog (same GetAllDDModelManagement source used
    // by ModelManagement.vue's create/edit form) so import validation can check that
    // the imported provider/model actually exist, instead of trusting the JSON file.
    loadImportModelCatalog() {
      let self = this;
      self.importCatalogLoading = true;
      self.importCatalogLoaded = false;
      self.$call.GetAllDDModelManagement(
        null,
        (dataResponse) => {
          self.importCatalogLoading = false;
          if (dataResponse.status == 0 && dataResponse.data) {
            self.importModelCatalog = {
              providers: dataResponse.data.provider || [],
              models: dataResponse.data.modelData || [],
            };
            self.importCatalogLoaded = true;
          } else {
            self.importModelCatalog = { providers: [], models: [] };
          }
        },
        (errorResource) => {
          self.importCatalogLoading = false;
          self.importModelCatalog = { providers: [], models: [] };
          console.error(errorResource);
        }
      );
    },
    // Catalog "model" entries store their value/display pair as "value|display" (same
    // convention as GPTModel.Model/ModelNameDisplay). Split logic mirrors the backend's
    // `request.model.Split('|')` in ManageGPTModelBAL.cs so matching stays consistent.
    splitPipeModel(modelStr) {
      if (typeof modelStr !== "string" || modelStr.length === 0) {
        return { id: null, display: null };
      }
      const parts = modelStr.split("|");
      return parts.length > 1
        ? { id: parts[0], display: parts[1] }
        : { id: modelStr, display: modelStr };
    },
    getImportField(data, ...keys) {
      for (const key of keys) {
        if (data[key] !== undefined && data[key] !== null && data[key] !== "") {
          return data[key];
        }
      }
      return null;
    },
    findCatalogProvider(providerName) {
      if (!providerName) return null;
      return (
        (this.importModelCatalog.providers || []).find(
          (p) => (p.providerName || "").toLowerCase() === providerName.toLowerCase()
        ) || null
      );
    },
    findCatalogModel(providerName, modelField) {
      const importedId = this.splitPipeModel(modelField).id;
      if (!providerName || !importedId) return null;
      return (
        (this.importModelCatalog.models || []).find((m) => {
          const catalogId = this.splitPipeModel(m.modelName).id;
          return (
            (m.provider || "").toLowerCase() === providerName.toLowerCase() &&
            (catalogId || "").toLowerCase() === importedId.toLowerCase()
          );
        }) || null
      );
    },
    validateImportJson(data) {
      const errors = [];
      if (!data || typeof data !== "object" || Array.isArray(data)) {
        errors.push("File does not contain a valid model configuration object.");
        return { checked: true, valid: false, errors, data: null };
      }

      // Real export files use PascalCase (Model/Provider); some hand-edited files also
      // carry a lowercase duplicate. Accept either.
      const provider = this.getImportField(data, "provider", "Provider");
      const model = this.getImportField(data, "Model", "model");

      if (!model || typeof model !== "string") {
        errors.push("Missing required field: model.");
      }
      if (!provider || typeof provider !== "string") {
        errors.push("Missing required field: provider.");
      }
      if (errors.length > 0) {
        return { checked: true, valid: false, errors, data: null };
      }

      if (!this.importCatalogLoaded) {
        errors.push("Model catalog is not loaded. Close and reopen the import dialog, then try again.");
        return { checked: true, valid: false, errors, data: null };
      }

      // Validate that provider/model are real, supported model types - not just non-empty strings.
      const catalogProvider = this.findCatalogProvider(provider);
      if (!catalogProvider) {
        errors.push(`Unsupported provider: "${provider}" is not a registered provider.`);
      }

      const catalogModel = this.findCatalogModel(provider, model);
      if (catalogProvider && !catalogModel) {
        errors.push(`Unsupported model: "${this.splitPipeModel(model).id}" is not a registered model for provider "${provider}".`);
      }

      // temperature: 0-2 (validateInput0_2), topP: 0-1 (validateInput0_1)
      const temperature = this.getImportField(data, "temperature", "Temperature");
      if (temperature !== null) {
        const temperatureResult = this.validateInput0_2(temperature);
        if (temperatureResult !== true) {
          errors.push(`Invalid temperature: ${temperatureResult}`);
        }
      }

      const topP = this.getImportField(data, "topP", "TopP", "top_p");
      if (topP !== null) {
        const topPResult = this.validateInput0_1(topP);
        if (topPResult !== true) {
          errors.push(`Invalid topP: ${topPResult}`);
        }
      }

      const maxTokens = this.getImportField(data, "maxTokens", "MaxTokens", "max_tokens");
      if (maxTokens !== null) {
        const maxTokensNum = Number(maxTokens);
        if (!Number.isFinite(maxTokensNum) || maxTokensNum <= 0) {
          errors.push("Invalid maxTokens: must be a number greater than 0.");
        } else if (catalogModel && catalogModel.maxToken && maxTokensNum > catalogModel.maxToken) {
          errors.push(`Invalid maxTokens: exceeds the model's maximum of ${catalogModel.maxToken}.`);
        }
      }

      const isStream = this.getImportField(data, "isStream", "IsStream");
      if (isStream !== null && typeof isStream !== "boolean") {
        errors.push("Invalid isStream: must be true or false.");
      }

      const isPublish = this.getImportField(data, "isPublish", "IsPublish");
      if (isPublish !== null && typeof isPublish !== "boolean") {
        errors.push("Invalid isPublish: must be true or false.");
      }

      if (errors.length > 0) {
        return { checked: true, valid: false, errors, data: null };
      }

      // Provider/model matched a real catalog entry - derive model identity/metadata from
      // the catalog instead of trusting whatever ModelType/APIVersion/etc. was in the file.
      const enriched = {
        ...data,
        provider: catalogProvider.providerName,
        model: catalogModel.modelName,
        modelType: catalogModel.modelType || null,
        APIVersion: catalogModel.apiVersion || null,
        jsonRequest: catalogModel.jsonRequest || null,
        endPointURL: catalogModel.endPointURL || null,
        apI_Key: catalogModel.apI_Key || null,
      };
      delete enriched.Provider;
      delete enriched.Model;
      delete enriched.ModelType;

      return { checked: true, valid: true, errors: [], data: enriched };
    },
    handleImportFileSelected(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.importFileRawText = e.target.result;
        this.importFileNameRaw = file.name;
        this.importJsonData = null;
        this.importValidation = { checked: false, valid: false, errors: [] };
      };
      reader.readAsText(file);
      event.target.value = "";
    },
    validateImportFile() {
      if (!this.importFileRawText) return;
      let parsed;
      try {
        parsed = JSON.parse(this.importFileRawText);
      } catch {
        this.importJsonData = null;
        this.importValidation = {
          checked: true,
          valid: false,
          errors: ["The selected file is not valid JSON."],
        };
        return;
      }
      const result = this.validateImportJson(parsed);
      this.importJsonData = result.valid ? result.data : null;
      this.importValidation = { checked: true, valid: result.valid, errors: result.errors };
    },
    submitImport() {
      if (!this.canSubmitImport) return;
      let self = this;
      self.importSubmitting = true;
      const payload = { ...self.importJsonData, modelName: self.importModelName.trim() };
      self.$call.ImportFileModelConfig(
        payload,
        (dataResponse) => {
          self.importSubmitting = false;
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: "success",
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.totalTable = self.totalTable + 1;
            self.closeImportDialog();
            self.Get();
          }
        },
        (errorResource) => {
          self.importSubmitting = false;
          console.error(errorResource);
        }
      );
    },
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.options.page = 1;
      self.GetDefault();
    },
    Get() {
      let self = this;
      self.loadingTable = true;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        modelName: self.searchModelName,
        modelDisplayId: parseInt(self.searchModelId),
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableGPTModel(
        temp,
        (dataResponse) => {
          self.loading = false;
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      const { itemsPerPage } = self.options;
      let temp = {
        page: 1,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        modelName: self.searchModelName,
        modelDisplayId: parseInt(self.searchModelId),
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableGPTModel(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(item) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            html: `<div style="margin-bottom: 8px;">${this.$t(
              "confirmDeletionModelPart1"
            )} ${item.modelDisplay}</div>
                   <div><span style="font-weight: bold; color: #3085d6; font-size: 1.1em;">"${
                     item.modelName
                   }"</span> ${this.$t("confirmDeletionModelPart2")}?</div>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteGPTModel(
                item.modelId,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  self.EditdialogUser = false;
                  self.Get();
                  }else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.$router.push({
        name: "GPTModelDetail",
        query: {
          id: null,
        },
      });
    },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "GPTModelDetail",
        query: {
          id: item.modelId,
        },
      });
    },
    Clear() {
      let self = this;
      self.EditdialogUser = false;
      self.Adddialog = false;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      return (
        inputValue.length <= this.maxLengthChar ||
        "กรุณาฝรอฝข้อมูลตัวอัฝษรไม่เกิน " +
          this.convertNumberToStringFormat(this.maxLengthChar)
      );
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return "required.";
      return (
        (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) ||
        "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง"
      );
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (
        (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) ||
        "กรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง"
      );
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    changeProvider(value) {
      let self = this;
      if (value == null || value == "") {
        self.DDModelShow = self.DDModel;
        return "required.";
      }
      let ddm = self.DDModel.filter((e) => e.provider == value);
      if (ddm.length != 0) {
        self.DDModelShow = self.DDModel.filter((e) => e.provider == value);
      } else {
        self.DDModelShow = self.DDModel;
      }
    },
    changeModel(value) {
      let self = this;
      if (value == null || value == "") {
        self.maxLengthChar = 0;
        return "required.";
      }
      let ddm = self.DDModel.find((e) => e.model == value);
      if (ddm) {
        self.maxLengthChar = self.DDModel.find(
          (e) => e.model == value
        ).maxPrompt;
      }
    },
    changePublishNow(item, is_publish) {
      let self = this;
      self.dialog = true;
      if (item.isPublish == true && is_publish == true) {
        self.dialog = false;
        self.$swal.fire({
          icon: "info",
          title: this.$t("alreadyPublishedModel"),
          showConfirmButton: true,
          confirmButtonText: this.$t("gotIt"),
          confirmButtonColor: "#4BB543",
        });
        return;
      }
      self.$call.PublishGPTModel(
        item.modelId,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: "success",
              title:
                this.$t("publish") +
                " " +
                item.modelName +
                " " +
                this.$t("success"),
              showConfirmButton: false,
              timer: 2500,
            });
            self.Get();
          }
          self.dialog = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    changeRestoreNewVersion(item) {
      let self = this;
      self.dialog = true;
      self.$call.PublishGPTModel(
        item.modelId,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: "success",
              title:
                this.$t("restoreVersion") +
                " " +
                item.modelName +
                " " +
                this.$t("success"),
              showConfirmButton: false,
              timer: 2500,
            });
            self.Get();
          }else if (dataResponse.status == 2) {
            this.$router.push({
              name: "GPTModelDetail",
              query: {
                id: item.modelId,
              },
            });
          }
          self.dialog = false;
          self.dialog_version = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async Save() {
      let self = this;
      self.dialog = true;
      try {
        if (self.GPTModel.modelId == null) {
          await self.$call.AddGPTModel(
            self.GPTModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (self.GPTModel.modelId != null) {
          await self.$call.UpdateGPTModel(
            self.GPTModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async Replace(modelid, modelName) {
      let self = this;
      self.dialog_replace = true;
      self.replace_modelid = modelid;
      self.replace_modelName = modelName;
      self.replace_modelName2 = "";
      self.replace_modelid_list = [];

      let raw = { page: 1, perPage: self.totalTable };
      self.$call.GetTableGPTModel(
        raw,
        (result) => {
          self.replace_modelid_list = [];
          if (result.status == 0) {
            let model = result.data.data.filter((o) => o.modelId == modelid)[0];

            if (model.isPublish == true) {
              let models = result.data.data.filter(
                (o) => o.modelId != modelid && o.isPublish == true
              );
              self.replace_modelid_lists = models;
            } else {
              let models = result.data.data.filter((o) => o.modelId != modelid);
              self.replace_modelid_lists = models;
            }
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (error) => {
          self.dialog = false;
          self.isSearch = false;
          alert(error);
        }
      );
    },
    async ReplaceSave() {
      let self = this;
      self.dialog = true;

      if (self.replace_modelid_list == undefined) {
        self.dialog = false;
        return;
      }

      let model_id = self.replace_modelid;
      // let GPTModel_model_display = self.replace_modelid_lists.filter((o) => o.modelIDGroup == self.replace_modelid_list)[0].modelDisplay;
      let GPTModel_model_id = self.replace_modelid_lists.filter(
        (o) => o.modelIDGroup == self.replace_modelid_list
      )[0].modelId;
      // let GPTModel_is_publish = self.replace_modelid_lists.filter((o) => o.modelIDGroup == self.replace_modelid_list)[0].isPublish;
      self.$call.ReplaceGPTModel(
        {
          source: model_id,
          destination: GPTModel_model_id,
        },
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: this.$t("success"),
                showConfirmButton: false,
                timer: 2500,
              });
              self.Get();
            }
          }
          self.dialog_replace = false;
          self.dialog = false;
          return null;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.dialog_replace = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async ReplaceChange(value) {
      let self = this;
      self.replace_modelid = value;
    },
    toggleCompareMode() {
      this.compareMode = !this.compareMode;
      if (!this.compareMode) {
        this.selectedCompareModels = [];
        this.importedJsonFile = null;
      }
    },
    isModelSelectedForCompare(modelId) {
      return this.selectedCompareModels.some((m) => m.modelId === modelId);
    },
    isVersionSelectedForCompare(modelId) {
      return this.selectedCompareVersionIds.includes(modelId);
    },
    removeCompareModel(modelId) {
      this.selectedCompareModels = this.selectedCompareModels.filter((m) => m.modelId !== modelId);
    },
    toggleCompareSelection(type, itemOrId) {
      if (type === "version") {
        const selections = [...this.selectedCompareVersionIds];
        const selectionIndex = selections.indexOf(itemOrId);
        if (selectionIndex >= 0) {
          selections.splice(selectionIndex, 1);
          this.selectedCompareVersionIds = selections;
          return;
        }
        if (selections.length >= 2) {
          this.$swal.fire({
            icon: "info",
            title: "Compare supports 2 selections",
            text: "Please unselect one item before adding another.",
            confirmButtonColor: "#1976d2",
          });
          return;
        }
        selections.push(itemOrId);
        this.selectedCompareVersionIds = selections;
        return;
      }

      const item = itemOrId;
      const existingIndex = this.selectedCompareModels.findIndex((m) => m.modelId === item.modelId);
      if (existingIndex >= 0) {
        this.selectedCompareModels.splice(existingIndex, 1);
        return;
      }
      const slotCount = this.selectedCompareModels.length + (this.importedJsonFile ? 1 : 0);
      if (slotCount >= 2) {
        this.$swal.fire({
          icon: "info",
          title: "Compare supports 2 selections",
          text: "Please unselect one item before adding another.",
          confirmButtonColor: "#1976d2",
        });
        return;
      }
      this.selectedCompareModels.push({
        modelId: item.modelId,
        modelName: item.modelName,
        modelDisplay: item.modelDisplay,
        isPublish: item.isPublish,
      });
    },
    triggerJsonCompareUpload() {
      this.$refs.jsonCompareInput.click();
    },
    handleJsonCompareFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = JSON.parse(e.target.result);
          this.importedJsonFile = { name: file.name, data };
        } catch {
          this.$swal.fire({
            icon: "error",
            title: "Invalid JSON",
            text: "The selected file is not valid JSON.",
            confirmButtonColor: "#d33",
          });
        }
      };
      reader.readAsText(file);
      event.target.value = "";
    },
    removeImportedJson() {
      this.importedJsonFile = null;
    },
    fetchModelDetail(modelId) {
      return new Promise((resolve, reject) => {
        this.$call.GetGPTModelById(
          modelId,
          (dataResponse) => {
            if (dataResponse.status === 0) {
              resolve(dataResponse.data);
              return;
            }

            reject(new Error(dataResponse.message || "Unable to load model detail"));
          },
          (errorResource) => {
            reject(errorResource);
          }
        );
      });
    },
    buildCompareTitle(item, isVersionCompare) {
      if (!item) {
        return isVersionCompare ? "Selected Version" : "Selected Model";
      }

      if (isVersionCompare) {
        return `${item.isPublish ? "Current • " : ""}v${item.versioning} • ${item.updateBy || item.modelName || item.modelDisplay}`;
      }

      return `${item.isPublish ? "Current • " : ""}${item.modelDisplay || "-"} • ${item.modelName || "Unnamed"}`;
    },
    orderComparePair(models, items) {
      if (models.length !== 2 || items.length !== 2) {
        return {
          leftModel: models[0],
          rightModel: models[1],
          leftItem: items[0],
          rightItem: items[1],
        };
      }

      const isCurrent = (item) => Boolean(item && item.isPublish);
      if (isCurrent(items[0]) && !isCurrent(items[1])) {
        return {
          leftModel: models[1],
          rightModel: models[0],
          leftItem: items[1],
          rightItem: items[0],
        };
      }

      return {
        leftModel: models[0],
        rightModel: models[1],
        leftItem: items[0],
        rightItem: items[1],
      };
    },
    async openCompareFromSelection(selectionType) {
      const isVersionCompare = selectionType === "version";
      const hasImportedJson = !isVersionCompare && this.importedJsonFile;
      const selectedIds = isVersionCompare
        ? this.selectedCompareVersionIds
        : this.selectedCompareModels.map((m) => m.modelId);

      const totalSlots = selectedIds.length + (hasImportedJson ? 1 : 0);
      if (totalSlots !== 2) {
        this.$swal.fire({
          icon: "info",
          title: "Select 2 items",
          text: "Please select 2 models, or 1 model + a JSON file to compare.",
          confirmButtonColor: "#1976d2",
        });
        return;
      }

      const selectedItems = isVersionCompare
        ? selectedIds.map((id) => this.menus_version.find((item) => item.modelId === id)).filter(Boolean)
        : this.selectedCompareModels;

      this.compareLoading = true;
      try {
        const compareModels = await Promise.all(
          selectedIds.map((selectedId) => this.fetchModelDetail(selectedId))
        );

        if (hasImportedJson) {
          // 1 model + 1 JSON file
          const modelData = compareModels[0];
          const modelItem = selectedItems[0];
          const jsonData = this.importedJsonFile.data;
          const jsonTitle = this.importedJsonFile.name;

          this.comparePayload = {
            leftModel: modelData,
            rightModel: jsonData,
            leftTitle: this.buildCompareTitle(modelItem, false),
            rightTitle: jsonTitle,
          };
          this.compareContextLabel = "Model vs File Compare";
        } else {
          const orderedPair = this.orderComparePair(compareModels, selectedItems);

          this.comparePayload = {
            leftModel: orderedPair.leftModel,
            rightModel: orderedPair.rightModel,
            leftTitle: this.buildCompareTitle(orderedPair.leftItem, isVersionCompare),
            rightTitle: this.buildCompareTitle(orderedPair.rightItem, isVersionCompare),
          };
          this.compareContextLabel = isVersionCompare ? "Version Compare" : "Model Compare";
        }

        this.dialog_compare = true;
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Compare failed",
          text: "Unable to load model details for the selected items.",
          confirmButtonColor: "#d33",
        });
      } finally {
        this.compareLoading = false;
      }
    },
    closeCompareDialog() {
      this.dialog_compare = false;
      this.comparePayload = {
        leftModel: null,
        rightModel: null,
        leftTitle: "",
        rightTitle: "",
      };
    },
    view(val) {
      let self = this;
      // self.dialog_version = false;
      self.view_modelID = val.modelId;
      self.isPage = "view model";
      self.dialog_View = true;
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async Version(modelId, modelIDGroup) {
      let self = this;
      self.dialog = true;
      if (self.dialog_version == false) {
        this.options_version.page = 1;
        this.options_version.itemsPerPage = 5;
      }

      self.dialog_version = true;
      self.menus_modelid_version = modelId;
      self.menus_modeliddisplay_version = modelIDGroup;

      const { page, itemsPerPage } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: itemsPerPage,
        modelId: modelId,
        modelIDGroup: modelIDGroup,
      };

      self.$call.GetTableGPTModelVersioning(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (
              dataResponse.data.total == 1 &&
              dataResponse.data.data[0].isPublish == false
            ) {
              self.menus_version = [];
            } else {
              self.menus_version = dataResponse.data.data;
            }
            self.selectedCompareVersionIds = self.selectedCompareVersionIds.filter(
              (selectedId) => self.menus_version.some((menu) => menu.modelId === selectedId)
            );
            self.searchTotalTable_version = dataResponse.data.total;
            self.totalTable_version = dataResponse.data.total;
          } else {
            self.menus_version = [];
            self.searchTotalTable_version = 0;
            self.totalTable_version = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Exportfileconfig(id, modelDisplayId, modelName) {
      let self = this;
      let req = {
        modelID: id,
      };
      self.dialog = true;
      self.$call.ExportFileConfigModel(
        req,
        (dataResponse) => {
          self.dialog = false;
          if (dataResponse) {
            // สร้าง FileReader เพื่ออ่าน Blob
            const reader = new FileReader();

            // เมื่อ FileReader โหลดเสร็จ
            reader.onload = function () {
              try {
                // แปลงผลลัพธ์จาก FileReader เป็น JSON
                const jsonResponse = JSON.parse(reader.result);
                //ทำการจัดการไฟล์
                let fileURL = window.URL.createObjectURL(
                  new Blob([JSON.stringify(jsonResponse, null, 2)])
                );
                let fileLink = document.createElement("a");

                fileLink.href = fileURL;
                let safeModelName = (modelName || "").replace(/[\\/:*?"<>|\s]+/g, "_");
                let fileName = `[${modelDisplayId}]_[${safeModelName}]_${self.convertDateToString(
                  new Date(),
                  ""
                )}.json`;
                fileLink.setAttribute("download", fileName);
                document.body.appendChild(fileLink);

                fileLink.click();
              } catch (error) {
                console.error("Error parsing JSON:", error);
              }
            };

            // เริ่มอ่าน Blob เป็นข้อความ
            reader.readAsText(new Blob([dataResponse]));
          }
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    convertDateToString(date, seperator = "-") {
      return dateUtils.getStringWithTimeFromDate2(
        moment(date).toDate(),
        seperator
      );
    },
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.GetDate();
    this.headers = [
      {
        title: "Compare",
        value: "compare",
        align: "center",
        sortable: false,
        width: "80px",
      },
      {
        title: "Model ID",
        value: "model_id",
        align: "center",
        sortable: false,
        width: "100px",
      },
      {
        title: "Model Name",
        value: "ModelName",
        align: "center",
        sortable: true,
      },
      { title: " ", value: " ", align: "center", sortable: false },
      { title: "Flow Name", value: "FlowName", align: "center", sortable: true },
      { title: "Flow Update Date", value: "FlowUpdateDate", align: "center", sortable: true },
      { title: "Provider", value: "Provider", align: "center", sortable: true },
      {
        title: "Model",
        value: "ModelNameDisplay",
        align: "center",
        sortable: true,
      },
      {
        title: "Create by",
        value: "CreateBy",
        align: "center",
        sortable: true,
      },
      { title: "Status", value: "IsPublish", align: "center", sortable: true },
      {
        title: this.$t("Manage"),
        value: "Manage",
        align: "center",
        width: "100px",
        sortable: false,
      }
    ];
    this.headers_version_history = [
      { title: "Compare", align: "center", sortable: false, width: "80px" },
      { title: "Version", align: "center", sortable: false, width: "150px" },
      { title: "Version Note", align: "center", sortable: false, width: "220px" },
      { title: "Modified", align: "center", sortable: false },
      { title: " ", align: "center", sortable: false },
      { title: "Modified By", align: "center", sortable: false },
    ];
    // this.Get();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.card {
  border-radius: 16px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* ปรับแต่ง responsive */
@media (max-width: 600px) {
  .justify-end {
    justify-content: flex-start;
  }
}

/* Action Controls */
.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 280px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* Control Buttons */
.control-btn {
  border-radius: 8px !important;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: none !important;
}

.import-btn {
  margin-left: 14px;
  width: 120px;
  box-shadow: 0 1px 3px rgba(33, 150, 243, 0.2);
}

.import-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(33, 150, 243, 0.3);
}

.create-btn {
  width: 120px;
  box-shadow: 0 1px 3px rgba(25, 118, 210, 0.2);
}

.create-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(25, 118, 210, 0.3);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .action-controls {
    width: 100%;
    justify-content: space-between;
    min-width: auto;
  }
  
  .control-btn {
    flex: 1;
    margin: 0 2px;
  }
}
.action-divider {
  width: 1px;
  height: 20px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 14px;
  align-self: center;
  border-radius: 1px;
}

/* Table improvements */
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

:deep(.v-data-table tbody tr) {
  transition: background-color 0.2s ease;
}

:deep(.v-data-table tbody tr:hover) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(.v-data-table-header) {
  background: rgba(0, 0, 0, 0.02);
}

:deep(.v-data-table-header th) {
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.7) !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.025em !important;
}

/* Search panel improvements */
.search-panel {
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.01);
}

/* Header improvements */
:deep(.v-toolbar) {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Smooth animations */
* {
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, 
              transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

/* Loading states */
.v-skeleton-loader {
  border-radius: 12px !important;
}

/* Focus states */
.control-btn:focus-visible {
  outline: 2px solid rgb(25, 118, 210);
  outline-offset: 2px;
}

/* Custom scrollbar */
:deep(.v-data-table__wrapper)::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

:deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.compare-dialog-card {
  border-radius: 18px !important;
}

.compare-dialog-header {
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.compare-dialog-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1f2937;
}

.compare-dialog-subtitle {
  font-size: 0.9rem;
  color: #6b7280;
  margin-top: 4px;
}

/* Compare Floating Bar */
.compare-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  border-top: 2px solid rgb(25, 118, 210);
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1);
  padding: 12px 24px;
}

.compare-floating-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.compare-floating-selections {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex: 1;
}

.compare-floating-label {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #1976d2;
  font-size: 0.9rem;
  white-space: nowrap;
}

.compare-chip-item {
  font-weight: 500;
}

.compare-floating-hint {
  color: #9e9e9e;
  font-size: 0.85rem;
  font-style: italic;
}

.compare-floating-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
